﻿export const isElement = (node: Node): node is Element => node instanceof Element;

export const isHTMLInputElement = (node: Node): node is HTMLInputElement => node instanceof HTMLInputElement;